import { render, staticRenderFns } from "./ProAlerta.vue?vue&type=template&id=52e0e695&"
import script from "./ProAlerta.vue?vue&type=script&lang=js&"
export * from "./ProAlerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports